import React, { ComponentType } from "react";

export const Loading: ComponentType = () => (
  <div className='loading-container'>
    <div className='loading' />
  </div>
)